import React from "react";
import { Subscribe } from "unstated";
import Alert from "react-bootstrap/Alert";

import { myGlobals, myUtilities } from "../../Utils";

import PaymentDataContainer from "../../Stores/PaymentDataContainerStore";
import { CANADA_COUNTRY_CODE, USA_COUNTRY_CODE } from "../../Utils/utils";

class MyInputNumeric extends React.Component {
  constructor(props) {
    super(props);
    this.myref = React.createRef();
    this.state = {
      showAlert: false,
      val: "",
    };
    this.paymentData = null;
  }

  handleChange = (event) => {
    let val = event.target.value;

    this.myref.current.setCustomValidity("");

    if (!Number.isNaN(Number(val)) && val.toString().length < 10) {
      this.setState({
        val: val,
      });
    } else if (val.toString().length === 0)
      this.setState({
        val: val,
      });
  };
  setPaymentData = (paymentData) => {
    this.paymentData = paymentData;
    if (
      this.state.val.length === 9 &&
      null !== this.paymentData.state[this.props.name] &&
      this.paymentData.state[this.props.name].localeCompare(
        this.myref.current.value
      ) !== 0
    )
      this.paymentData.populateInputData(
        this.props.name,
        this.myref.current.value
      );
  };

  alertContent = () => {
    if (this.state.showAlert) {
      return (
        <Alert className="my-alert-class" variant="danger">
          <p>
            {this.paymentData.getCurrentCountryCode().toUpperCase() === USA_COUNTRY_CODE
              ? myUtilities.accountSpecificLanguage(
                  "Validation.RoutingNo",
                  "Please enter 9 digit routing number"
                )
              : myUtilities.accountSpecificLanguage(
                  "Validation.RoutingNoFive",
                  "Please enter 5 digit transit branch number"
                )}
          </p>
        </Alert>
      );
    }
  };
  

  getValidationMessage = () =>
    this.state.val === "" || !this.state.val.match("[0-9]{9}")
      ? myUtilities.accountSpecificLanguage(
           "form.validation.error",
           "Please fill out this field.",
        )
      : "";

  onBlur = () => {

    if (this.paymentData.getCurrentCountryCode().toUpperCase() === USA_COUNTRY_CODE &&
      this.myref.current.value.toString().length !== 9) {
      this.setState({
        showAlert: true,
      });
    } 
    
    else if (this.paymentData.getCurrentCountryCode() === CANADA_COUNTRY_CODE
      && this.myref.current.value.toString().length !== 5) {
      this.setState({
        showAlert: true,
      });
    } 
    
    else {
      this.paymentData.populateInputData(
        this.props.name,
        this.myref.current.value
      );
    }
  };
  onFocus = () => {
    setTimeout(() => {
      this.setState({
        showAlert: false,
      });
    }, 3000);
  };

  render() {
    return (
      <Subscribe to={[PaymentDataContainer]}>
        {(data) => (
          <div>
            {this.setPaymentData(data)}
            {this.alertContent()}
            <input
              title={this.getValidationMessage()}
              ref={this.myref}
              value={this.state.val}
              required
              name={this.props.name}
              onInvalid={() =>
                this.myref.current.setCustomValidity(
                  myUtilities.accountSpecificLanguage(
                     "form.validation.error",
                     "Please fill out this field.",
                  )
                )
              }
              className="payment-input-label"
              pattern={data.getCurrentCountryCode().toUpperCase() === "US" ? "[0-9]{9}" : "[0-9]{5}"}
              type="text"
              maxLength={data.getCurrentCountryCode().toUpperCase() === "US" ? "9" : "5"}
              onChange={this.handleChange}
            ></input>
          </div>
        )}
      </Subscribe>
    );
  }

  componentDidMount() {
    this.myref.current.onblur = this.onBlur;
    this.myref.current.onfocus = this.onFocus;
  }
}
export default MyInputNumeric;
